export default __webpack_public_path__ + "static/media/ShennaLovelace.69359512.png";